import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { environment } from '../../../environments/environment';
import { globals } from '../../../environments/globals';
import { CountrySwitcherComponent } from '../country-switcher/country-switcher';

@Component({
    selector: 'footer-desktop',
    styleUrls: ['./footer-desktop.scss'],
    templateUrl: './footer-desktop.html',
    standalone: true,
    imports: [CommonModule, CountrySwitcherComponent]
})
export class FooterDesktopComponent implements OnInit {
  webURL: string = environment.webURL;
  appURL: string = environment.appURL;
  mediaURL: string = environment.mediaURL;
  slug: string | null = 'global';
  country: any;
  countries: any[] = globals.countries.filter((site: { active: boolean; }) => site.active);
  showCountries: boolean = false;
  year: number = 0;

  constructor(
    private route: ActivatedRoute,
    private router: Router
  ) { }

  ngOnInit() {
    let today = new Date();
    this.year = today.getFullYear();
    if (this.route.snapshot.paramMap.get('slug')) {
      this.slug = this.route.snapshot.paramMap.get('slug');
    } else {
      this.slug = 'global';
    }
    if (this.slug) {
      this.countries.forEach((country, i) => {
        if (this.slug == country.slug) {
          this.country = country;
        }
      })
    }
  }
}
